export default "__VITE_ASSET__BwZY90Th__"